module.exports = __webpack_public_path__ + "static/media/gpDownload.86f967ed.png";